import fetchClient from './fetchClient';
import { errorHandler } from './utils';


const config = () => {
    return {
        headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
        },
    };
};

export const getStock = async (category?: string): Promise<{ data: any; error: any }> => {
    const params = category && category !== 'all' ? { category } : {};
    const res: any = await fetchClient.get('/stock', { ...config(), params }).catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const getLightStock = async (): Promise<{ data: any; error: any }> => {
    const res: any = await fetchClient
        .get('/stock/light', config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const getLotNumbers = async (): Promise<{ data: any; error: any }> => {
    const res: any = await fetchClient
        .get('/stock/lot-numbers', config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const getLotNumbersTracking = async (
    id: string,
): Promise<{ data: any; error: any }> => {
    const res: any = await fetchClient
        .get(`/stock/tracking/${id}`, config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};

export const getStockAlerts = async (): Promise<{ data: any; error: any }> => {
    const res: any = await fetchClient
        .get('/stock/alert', config())
        .catch(errorHandler);
    if (res.error) return res;
    return { data: res ? res.data : null, error: null };
};
